import { Stack } from "@mantine/core";
import { TeamManager } from "@/components/Team/TeamManager/TeamManager";
import SettingsHeader from "@/pages/Settings/SettingsHeader/SettingsHeader";
import OnboardingPageContainer from "./OnboardingPageContainer";

interface TeamManagementOnboardingProps {
  onExit?: () => void;
}

/**
 * Team management view for onboarding flow
 * Wraps the TeamManager component with appropriate header
 */
const TeamManagementOnboarding = ({
  onExit,
}: TeamManagementOnboardingProps) => {
  return (
    <OnboardingPageContainer onExit={onExit}>
      <Stack gap="md">
        <SettingsHeader
          title="Team"
          description="Manage your team members and credit allocation"
        />
        <TeamManager />
      </Stack>
    </OnboardingPageContainer>
  );
};

export default TeamManagementOnboarding;
